import { all, fork } from 'redux-saga/effects';
import * as W from './watchers';

export function* integrationsSaga() {
  yield all([
    fork(W.watchGetCredentials),
    fork(W.watchPatchNetSuiteCredentials),
  ]);
}



